import CoachingConstants from 'coaching/CoachingConstants';
import { GetCoachAvailabilities_coaching_coachAvailability_availabilities } from 'coaching/queries/__generated__/GetCoachAvailabilities';
import { CoachAvailabilityInput, CoachAvailabilityInterval } from 'globalTypes';

export function constructAvailabilitiesByDay(
  existingAvailabilities?: (GetCoachAvailabilities_coaching_coachAvailability_availabilities | null)[]
) {
  // construct all 7 days of availability, slotting the existing availabilities
  // in at the right spots
  return CoachingConstants.SORTED_DAYS_OF_WEEK.map<CoachAvailabilityInput>(day => {
    const existingAvailability = existingAvailabilities?.find(
      availability => availability?.timeSlot?.dayOfWeek === day
    );
    const intervals = existingAvailability?.timeSlot?.intervals.map(interval => ({
      startTime: interval?.startTime,
      endTime: interval?.endTime,
    }));
    return {
      uuid: existingAvailability?.uuid ?? '',
      timeSlot: {
        dayOfWeek: day,
        intervals: (intervals as CoachAvailabilityInterval[]) ?? [],
      },
      // if maxSessions is unset, it comes in as 0 because of protobuf. we cast it to
      // undefined for purely cosmetic reasons, so the dropdowns will display the grey
      // "Any" placeholder text rather than the black "Any" that corresponds to value 0.
      maxSessions: existingAvailability?.maxSessions || undefined,
    };
  });
}
